import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import PropTypes from "prop-types";

export default function TableReportNormalQTWithActual({ headers, data, selectedRows = [], onSelectAll, onSelectRow }) {
  // Account for max 30 rows selection limit
  const maxSelectable = Math.min(data.length, 30);
  const isAllSelected = data.length > 0 && selectedRows.length === maxSelectable;
  const isIndeterminate = selectedRows.length > 0 && selectedRows.length < maxSelectable;
  return (
    <TableContainer component={Paper}>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            {(onSelectAll || onSelectRow) && (
              <TableCell padding="checkbox">
                <Checkbox
                  color="primary"
                  indeterminate={isIndeterminate}
                  checked={isAllSelected}
                  onChange={onSelectAll}
                  inputProps={{
                    "aria-label": "select all rows",
                  }}
                />
              </TableCell>
            )}
            {headers.map((header, index) =>
              header.col ? (
                <TableCell
                  key={`cell${index}`}
                  align="center"
                  colSpan={header.col.length}
                >
                  <div className="">{header.name}</div>
                  <div className="flex justify-between mt-4">
                    {header.col.map((col, index) => (
                      <div key={`col${index}`} className="">
                        {col.name}
                      </div>
                    ))}
                  </div>
                </TableCell>
              ) : (
                <TableCell key={`cell${index}`} align="center" colSpan={0}>
                  {header.name}
                </TableCell>
              )
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((dataLoop, index) => {
            const isItemSelected = selectedRows.includes(dataLoop.id);
            return (
              <TableRow
                key={index}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                {(onSelectAll || onSelectRow) && (
                  <TableCell padding="checkbox">
                    <Checkbox
                      color="primary"
                      checked={isItemSelected}
                      onChange={(event) => onSelectRow(event, dataLoop.id)}
                    />
                  </TableCell>
                )}
                <TableCell component="th" align="center" scope="row">
                  {index + 1}
                </TableCell>
              <TableCell align="center">{dataLoop.createAt}</TableCell>
              <TableCell align="center">{dataLoop.jobNo}</TableCell>
              {dataLoop.data.actual ? (
                dataLoop.data.actual.map((actual, index) => (
                  <TableCell key={`cell${index}`} align="center">
                    {actual.toString() || "-"}
                  </TableCell>
                ))
              ) : (
                <>
                  <TableCell align="center">-</TableCell>
                  <TableCell align="center">-</TableCell>
                  <TableCell align="center">-</TableCell>
                </>
              )}
              <TableCell align="center">{dataLoop.average}</TableCell>
              <TableCell align="center">{dataLoop.inspector}</TableCell>
              <TableCell align="center">{dataLoop.checker}</TableCell>
            </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

TableReportNormalQTWithActual.propTypes = {
  headers: PropTypes.array,
  data: PropTypes.array,
  selectedRows: PropTypes.array,
  onSelectAll: PropTypes.func,
  onSelectRow: PropTypes.func,
};
